import type * as React from 'react';

import type { BlockProps } from '@gitbook/slate-react';

import { usePlainMarkdownStyle } from '../usePlainMarkdownStyle';
import { BasicBlockWrapper } from './BasicBlockWrapper';

/*
 * Basic renderer for a paragraph block.
 */
export function BasicBlockParagraph(props: BlockProps): React.ReactElement {
    const { children, ...rest } = props;

    const { textStyle } = usePlainMarkdownStyle();

    return (
        <BasicBlockWrapper tag="p" {...rest}>
            <span style={textStyle}>{children}</span>
        </BasicBlockWrapper>
    );
}
